import { environment } from '@environments/environment';

export const auth0Config = {
    domain: environment.auth.domain,
    clientId: environment.auth.clientId,
    authorizationParams: {
        redirect_uri: window.location.origin,
        audience: environment.auth.audience
    },
    httpInterceptor: {
        allowedList: [
            {
                uri: `${environment.apiUrl}/api/*`,
                tokenOptions: {
                    authorizationParams: {
                        audience: environment.auth.audience
                    }
                }
            },
            {
                uri: `/api/*`,
                tokenOptions: {
                    authorizationParams: {
                        audience: environment.auth.audience
                    }
                }
            }
        ]
    }
};
